// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1DXRc","image":"Header_image__13Vea","name":"Header_name__2ZSIm","info":"Header_info__1PEw8","infoRow":"Header_infoRow__DkOS8"};